<template>
  <div>
    <el-upload class="upload-imgs" :list-type="listType" :limit="limit" :action="uploadUrl" :data="extraData"
      :before-upload="beforeImgUpload" :on-remove="imgRemove" :on-success="imgUploadSuccess" :on-error="uploadError"
      :on-preview="pictureCardPreview" :on-exceed="imgExceed" :before-remove="beforeImgRemove" :file-list="fileList"
      :accept="accept" :disabled="disabled" :headers="headers" name="filedata">
      <i class="el-icon-plus" v-if="listType == 'picture-card'"></i>
      <el-button type="primary" v-else>点击上传</el-button>
    </el-upload>
    <!-- 图片预览弹窗 -->
    <el-dialog :visible.sync="dialogImg" append-to-body>
      <img width="100%" :src="dialogImageUrl" alt="点击预览" />
    </el-dialog>
  </div>
</template>

<script>
import { uploadUrl } from "@/api/public.js"
import { getToken } from "@/utils/auth" // get token from cookie
export default {
  data() {
    return {
      uploadUrl,
      dialogImg: false,
      dialogImageUrl: "",
      headers: {
        token: getToken()
      }
    }
  },
  props: {
    accept: {
      type: String,
      default: ".jpg, .jpeg, .png, .doc, .docx, .xls, .xlsx, .pdf, .zip, .rar"
    },
    extraData: {
      //文件上传的额外参数
      type: Object
    },
    field: {
      //文件字段名
      type: String,
      default: ""
    },
    limit: {
      type: Number,
      default: 10
    },
    fileList: {
      //图片初始值
      type: Array,
      default: () => {
        return []
      }
    },
    listType: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    beforeImgUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isLt5M) {
        this.$message.error("上传文件大小不能超过 5MB!")
      }
      return isLt5M
    },
    imgRemove(file, fileList) {
      this.$emit("fileChange", fileList, this.field)
    },
    imgUploadSuccess(response, file, fileList) {
      if (!response.status) {
        if (response.msg) {
          this.$message.error(response.msg)
        } else {
          this.$message.error("上传失败！")
        }
        fileList = fileList.filter((item) => item.url.indexOf("blob:http") == -1)
        this.$emit("fileChange", fileList, this.field)
        return
      }

      //便于预览文件
      file.url = response.outputData.FilePath

      this.$emit("fileChange", fileList, this.field)
    },
    uploadError(err, file, fileList) {
      this.$message.error("文件上传失败.")
    },
    pictureCardPreview(file) {
      if (/\.(png|jpg|jpeg|PNG|JPG|JPEG)$/.test(file.url)) {
        this.dialogImageUrl = file.url
        this.dialogImg = true
      } else {
        window.open(file.url, "_blank")
        // window.open(
        //   "https://view.officeapps.live.com/op/view.aspx?src="+file.url,
        //   "_blank"
        // )
      }
    },
    imgExceed(files, fileList) {
      this.$message.warning(`当前限制选择 ${this.limit} 个文件`)
    },
    beforeImgRemove(file, fileList) {
      if (file && file.status == "success") {
        return this.$confirm(`确定移除该文件？`, "提示", { type: "warning" })
      }
    }
  }
}
</script>

<style scoped="scoped" lang="scss"></style>
